import React, { useState, useEffect } from 'react';
import { auth } from '../../firebaseConfig'; // Adjust the path if necessary
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from 'react-router-dom';

import ErrorNotification from '../../components/notification/ErrorNotification';

import './AdminSignIn.less';
import { Input } from 'antd';

const AdminSignIn = () => { 
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                navigate('/admin/items');
            }
        });

        return () => unsubscribe();
    }, [navigate]);

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError(null);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    const handleSignIn = async () => {
        setLoading(true);
        setError(null);
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/admin/items'); 
        } catch (error: any) {
            setError('Error Signing In: Invalid Credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='admin-sign-in-container'>
            {loading && (
                <div className="loading-modal">
                    <div className="loading-spinner"></div>
                </div>
            )}
            {error && (
                <ErrorNotification message={error}/>
            )}
            <form className="admin-sign-in">
                <p className="admin-sign-in-title">Sign in to admin account</p>
                <div className="admin-sign-in-input-container">
                    <Input
                        type="email" 
                        placeholder="Enter email" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="admin-sign-in-input-container">
                    <Input
                        type="password" 
                        placeholder="Enter password" 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="button" className="admin-sign-in-submit" onClick={handleSignIn}>Sign in</button>
                {/* <p className="signup-link">
                    No account?
                    <a href="">Sign up</a>
                </p> */}
            </form>
        </div>
    );
};

export default AdminSignIn;
